export default __webpack_public_path__ + "static/media/move.8b2bfb8c.PNG";